module.exports = "a {\n  display: block;\n  padding: 3px 20px;\n  clear: both;\n  font-weight: normal;\n  line-height: 1.42857143;\n  color: #333333;\n  white-space: nowrap;\n  text-decoration: none;\n  cursor: pointer; }\n  a:hover {\n    text-decoration: none;\n    color: #262626;\n    background-color: #f5f5f5; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal-edit/modal-edit.component.scss
// module id = ./src/app/modal-edit/modal-edit.component.scss
// module chunks = main